import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';
import { API_URL } from '../constants/urls';

export interface APIKey {
  id: string;
  name: string;
  prefix: string;
  created_at: string;
  last_used_at: string | null;
  expires_at?: string | null;
  is_active: boolean;
}

export interface APIKeyCreate {
  name: string;
}

export interface APIKeyResponse {
  id: string;
  name: string;
  key: string; // Full key, only returned on creation
  prefix: string;
  created_at: string;
}

const API_KEY_URL = `${API_URL}/auth/api-keys`;

export const apiKeyService = {
  async listAPIKeys(): Promise<APIKey[]> {
    const response = await axios.get(`${API_KEY_URL}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  async createAPIKey(data: APIKeyCreate): Promise<APIKeyResponse> {
    const response = await axios.post(`${API_KEY_URL}`, data, {
      headers: getAuthHeaders(),
    });
    return response.data;
  },

  async revokeAPIKey(keyId: string): Promise<void> {
    await axios.patch(
      `${API_KEY_URL}/${keyId}/revoke`,
      {},
      {
        headers: getAuthHeaders(),
      },
    );
  },

  async deleteAPIKey(keyId: string): Promise<void> {
    await axios.delete(`${API_KEY_URL}/${keyId}`, {
      headers: getAuthHeaders(),
    });
  },
};
